
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class ShipperSelectDialog extends Serenity.PropertyDialog<any, any>
    {

        protected form = new ShipperSelectForm(this.idPrefix);
        public entity: any;
        public voucherno: string;
        public vouchertypeid: number;
        public inst;
        public checksuccess: boolean;
        public status: number;
        public _checklist: ECommerce.OrderManagementCheckListRow[];
        constructor() {
            super();

            this.form = new ShipperSelectForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Approve";
        }

        protected onDialogOpen() {
            super.onDialogOpen();
        }


        protected getDialogButtons() {
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;
                        var shippingdialog = new ECommerce.ShippingDialog();


                        var itemdetails = [];


                        var self = this;
                        var voucher = FormatHelper.GetVoucherNo(80);
                        let now = new Date();
                        let salesitem: CommonItemsRow;
                        ECommerce.ECommSalesItemsService.ShipmentItemList({ Line_No: self.entity.Line_No }
                            , response => {
                                if (response.Entities.length > 0) {
                                    salesitem= response.Entities.pop();
                                    
                                }
                            }, { async: false })
                        if (salesitem != null) {
                            salesitem.ECommOrderId = self.entity.ECommOrderId;
                            salesitem.ECommOrderItemId = self.entity.ECommOrderItemId;
                            salesitem.Line_No = self.entity.Line_No;
                            salesitem.GrossAmount = salesitem.GrossAmount + salesitem.TaxAmount;

                        }
                        var x: CommonItemsRow = {
                            VoucherTypeId: 80,
                            RefVoucherId: salesitem.VoucherTypeId,
                            DepartmentId: salesitem.DepartmentId,
                            ProductId: salesitem.ProductId,
                            ProductName: salesitem.ProductName,
                            ProductCode: salesitem.ProductCode,
                            PartyId: salesitem.PartyId,
                            Line_No: salesitem.Line_No,
                            BagNo: salesitem.BagNo,
                            SKU: salesitem.SKU,
                            LotNo: salesitem.LotNo,
                            CertificateNo: salesitem.CertificateNo,
                            RefNo: salesitem.RefNo,
                            AttributeId: salesitem.AttributeId,
                            Studded: salesitem.Studded,
                            Pieces: salesitem.Pieces,
                            Weight: salesitem.Weight,
                            NetWeight: salesitem.NetWeight,
                            DiamondPieces: salesitem.DiamondPieces,
                            DiamondWeight: salesitem.DiamondWeight,
                            StonePieces: salesitem.StonePieces,
                            StoneWeight: salesitem.StoneWeight,
                            OtherPieces: salesitem.OtherPieces,
                            OtherWeight: salesitem.OtherWeight,
                            MetalAmount: salesitem.MetalAmount,
                            DiamondAmount: salesitem.DiamondAmount,
                            StoneAmount: salesitem.StoneAmount,
                            OtherAmount: salesitem.OtherAmount,
                            CalcOnId: salesitem.CalcOnId,
                            UnitRate: salesitem.UnitRate,
                            UnitLabour: salesitem.UnitLabour,
                            UnitCost: salesitem.UnitCost,
                            NetAmount: salesitem.NetAmount,
                            Discount: salesitem.Discount,
                            DiscountPer: salesitem.DiscountPer,
                            GrossAmount: salesitem.GrossAmount,
                            CCGrossAmount: salesitem.CCGrossAmount,
                            CCNetAmount: salesitem.CCNetAmount,
                            RefTransItemId: salesitem.TransItemId,
                            RefTransId: salesitem.TransId,
                            ImageName: salesitem.ImageName,
                            Remark: salesitem.Remark,
                            SpecialRemark: salesitem.SpecialRemark,
                            UserDescription: salesitem.UserDescription,
                            ServerDate: salesitem.ServerDate,
                            Remarks: salesitem.Remarks,
                            IsDisabled: salesitem.IsDisabled,
                            AckStatus: salesitem.AckStatus,
                            DeliveryDate: salesitem.DeliveryDate,
                            CompanyId: salesitem.CompanyId,
                            BagStatus: salesitem.BagStatus,
                            WstPer: salesitem.WstPer,
                            WstWt: salesitem.WstWt,
                            Purity: salesitem.Purity,
                            PureWeight: salesitem.PureWeight,
                            HSN: salesitem.HSN,
                            ECommOrderId : salesitem.ECommOrderId,
                            ECommOrderItemId : salesitem.ECommOrderItemId
                        };
                        itemdetails.push(x);
                        var _entity: ECommerce.ShippingRow = {
                            VoucherNo: voucher,
                            VoucherTypeId: 80,
                            CompanyId: Q.Authorization.userDefinition.CompanyId,
                            FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                            UserId: Q.Authorization.userDefinition.UserId,
                            CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                            TransDate: now.toDateString(),
                            POSCustomerId: x.PartyId,
                            ItemDetails: itemdetails,
                            Pieces: x.Pieces,
                            Weight: x.Weight,
                            NetWeight: x.NetWeight,
                            GrossAmount: salesitem.BalanceAmount,
                            ReceiptAmount: x.GrossAmount - salesitem.BalanceAmount,
                            NetAmount: x.NetAmount,
                            FreightId: parseInt(self.form.Freight.value),
                            ECommOrderId: salesitem.ECommOrderId
                        }


                        shippingdialog.loadEntityAndOpenDialog(_entity, false);

                        //this.status = 4;
                        //for (var i = 0; i < checklist.length; i++) {
                        //    if (checklist[i].CheckListValue == false)
                        //        this.status = 3;
                        //}
                        //this._checklist = checklist;

                        shippingdialog.element.on('dialogclose', () => {

                            this.checksuccess = true;
                            this.dialogClose();
                        });
                        return true;
                    },
                },
                {
                    text: 'Cancel',
                    click: () => {
                        this.checksuccess = false;
                        this.dialogClose();

                    }
                }
            ];
        }
    }

    class CommonItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        ProductId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        ItemTypeId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        DiscountPer?: number;
        GrossAmount?: number;
        CCGrossAmount?: number;
        CCNetAmount?: number;
        RefTransItemId?: number;
        RefTransTypeId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        Status?: string;
        MetalId?: number;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
        HSN?: string;
        HasBom?: boolean;
        Parts?: number;
        VoucherNo?: string;
        TransDate?: string;
        DeptName?: string;
        PosCustomerCode?: string;
        CustomerName?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        ECommOrderId?: number;
        ECommOrderItemId?: number;
        TaxAmount?: number;
        BalanceAmount?: number;
    }
}